import * as z from "zod";

/** Mints a fresh Adyen hosted-onboarding link on the merchant's click; the page redirects to it. */
export const startHsaAdyenKyc = {
  name: "startHsaAdyenKyc" as const,
  input: z.null(),
  output: z.object({ onboardingUrl: z.string() }),
};
